<template>
  <div>
    <button type="button" class="download-btn" v-on:click="download">
      Download
    </button>
  </div>
</template>

<style scoped>
.download-btn {
  background-color: DodgerBlue;
  border: none;
  color: white;
  padding: 12px 30px;
  margin: 12px 0;
  cursor: pointer;
  font-size: 20px;
}
/* Darker background on mouse-over */
.download-btn:hover {
  background-color: RoyalBlue;
}
</style>

<script>
import XLSX from "xlsx-js-style";

export default {
  name: "ExportVidget",
  components: {},
  data() {
    return {
      items: [
        { age: 40, first_name: "Dickerson", last_name: "Macdonald" },
        { age: 21, first_name: "Larsen", last_name: "Shaw" },
        { age: 89, first_name: "Geneva", last_name: "Wilson" },
        { age: 38, first_name: "Jami", last_name: "Carney" },
      ],
    };
  },
  methods: {
    download: function () {
      //   const data = XLSX.utils.json_to_sheet(this.items);
      //   const wb = XLSX.utils.book_new();
      //   XLSX.utils.book_append_sheet(wb, data, "data");

      //   var ws = wb.Sheets[0];
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017, 12, 19),
      };
      wb.SheetNames.push("Test Sheet");
      var ws_data = [["hello", "world"]]; //a row with 2 columns
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Test Sheet"] = ws;

      ws["A1"].s = {
        font: {
          name: "Calibri",
          sz: 16,
          bold: true,
          color: { rgb: "FFFFAA00" },
        },
      };
      XLSX.writeFile(wb, "demo.xlsx");
    },

    
  },
};
</script>